import React, { useRef, useState } from 'react'
import Modal from '../../common/modal/Modal'
import ResponseMessage from '../../common/modal/ResponseMessage'
import ProcessingCSV from './ProcessingCSV'
import MicroModal from 'micromodal'
import { performRequest } from '../../common/utils'
import TableCsvMapping from './TableCsvMapping'
import AddSeats from './AddSeats'
import { HandleShowCloseModal } from '../../common/modal/HandleShowCloseModal'

const UploadCSV = ( props ) => {
    const team = JSON.parse( props['data-team'] )
    // console.log('team : ', team)
    const modalClassNames = props['data-modal-classnames'] ?? props.modalClassNames
    const [ inputFile, setInputFile ] = useState()
    const [ responseMessage, setResponseMessage ] = useState()
    const [ uploadCsvResponse, setUploadCsvResponse ] = useState()
    // console.log('uploadCsvResponse : ', uploadCsvResponse)
    const [ mapCsvResponse, setMapCsvResponse ] = useState()
    const [ tableData, setTableData ] = useState()
    const [ importOptions, setImportOptions ] = useState({
        ignoreUsersIfMember: false,
        importOption: team.import_option
    })
    const fileInputRef = useRef(null)
    const seatBtn = team.is_admin ? "Grant More Seats" : "Buy More Seats"
    const canUseTeamIdOption = team.is_admin || team.can_manage ? true : false
    const [isLoading, setIsLoading] = useState({
        uploadingCSV: false,
        importingCSV: false
    })

    MicroModal.init()

    const inputFileChange = (e) => {
        setResponseMessage()
        const csvData = e.target.files[0] ?? {}
        const csvExtension = csvData['name'] ? csvData['name'].split('.').pop() : false

        if( csvData && csvExtension !== 'csv'){
            setResponseMessage({
                type: 'error',
                message: 'Invalid file extension'
            })
            resetFileInput()
            return
        }

        setInputFile( csvData )
    }

    const resetFileInput = () => {
        fileInputRef.current.value = ''
        setInputFile()
        setUploadCsvResponse()
        setMapCsvResponse()
        MicroModal.close('msync-modal-processing-import')
    }

    const checkImportOption = ( action ) => {
        setImportOptions(prevState => ({
            ...prevState,
            importOption: action
        }))
    }

    const checkHandlerIgnoreUsers = () =>{
        setImportOptions(prevState => ({
            ...prevState,
            ignoreUsersIfMember: !prevState.ignoreUsersIfMember
        }))
    }

    const uploadCsv = async () => {
        if( !inputFile ){
            setResponseMessage({
                type: 'error',
                message: 'File cannot be empty'
            })
            return
        }

        if( uploadCsvResponse ){
            setResponseMessage({
                type: 'error',
                message: 'Cannot re-upload same file'
            })
            return
        }

        if( team.subscription_status ){
            const subscriptionStatus = team.subscription_status

            if( (['cancelled', 'expired']).includes( subscriptionStatus ) ){
                setResponseMessage({
                    type: 'error',
                    message: 'Team subscription has been cancelled or expired'
                })
                return
            }
        }

        try {
            setIsLoading(prevState => ({
                ...prevState,
                uploadingCSV: true
            }))

            const formData = new FormData()
            formData.append('action', msyncCsvImport.create)
            formData.append('csv', inputFile)
            formData.append('nonce', msyncCsvImport.nonce_create)
            formData.append('team_id', team.team_id)
            formData.append('team_type', team.team_type)
            formData.append('ignore_existing', importOptions.ignoreUsersIfMember ? true : "" )
            formData.append('import_option', importOptions.importOption ?? 'automatic' )
            
            const request = await performRequest( msyncCsvImport.url, formData )
            const res = await request.json()
            const isAllowedToImport = team.team_remaining_seat >= res.rowcount || team.team_seat_count === null || team.team_type !== 'wooteams'
            if( !res.success ){
                throw new Error( res.errors.shift() )
            }

            setUploadCsvResponse({...res, isAllowedToImport})
            setNewTanstackData(res)

        } catch (error) {
            setResponseMessage({
                type:'error',
                message: error.message
            })
        } finally{
            setIsLoading(prevState => ({
                ...prevState,
                uploadingCSV: false
            }))
        }
    }

    const importAction = async() => {
        setResponseMessage()

        if( !uploadCsvResponse ){
            setResponseMessage({
                type: 'error',
                message: 'Cannot import without uploading the CSV!'
            })
            return
        }

        try {
            setIsLoading(prevState => ({
                ...prevState,
                importingCSV: true
            }))

            const formData = new FormData()
                
            const dataMapped = tableData.reduce((acc, data) => {
                if( data.selected === "" ) return acc
                acc[data.selected] = data.csvHeader
                return acc
            }, {})

            const checkEmailKeyExist = Object.keys( dataMapped ).includes('email')
        
            if( !checkEmailKeyExist ) {
                throw new Error( 'Email selection is required' )
            }

            formData.append('action', msyncCsvImport.map)
            formData.append('uid', uploadCsvResponse.uid)
            formData.append('nonce', msyncCsvImport.nonce_map)
            formData.append('map', JSON.stringify( dataMapped ) )

            const request = await performRequest( msyncCsvImport.url, formData )
            const res = await request.json()

            if( !res.success ){
                throw new Error( res.errors.shift() )
            }

            setMapCsvResponse(res)

            HandleShowCloseModal('msync-modal-processing-import', 'msync-upload-csv-modal')
        } catch (error) {
            setResponseMessage({
                type:'error',
                message: error.message
            })
        }
        finally{
            setIsLoading(prevState => ({
                ...prevState,
                importingCSV: false
            }))
        }

    }

    const setNewTanstackData = ( response ) => {

        const newData = Object.keys(response.row).map((res, i) => {
            // Find the best match using regex
            const selected = team.csv_headers.find((header) => {
                const regex = new RegExp(header.replace(/_/g, "\\s*"), "i");
                return (
                    res.replace(/_/g, " ").match(regex) ||
                    header
                    .replace(/_/g, "\\s*")
                    .match(new RegExp(res.replace(/_/g, "\\s*"), "i"))
                )
            }) || ""
    
            return {
                csvHeader: res,
                value: Object.values(response.row)[i],
                selected: selected
            }
        })

        return setTableData(newData)
    }

    const handleAddSeatBtn = () => {
        HandleShowCloseModal('msync-modal-add-seats', 'msync-upload-csv-modal')
    }

    const handleCloseCSVModal = () => {
      if( isLoading.uploadingCSV || isLoading.importingCSV ) return
      if( inputFile || fileInputRef.current.value ){
        const result = window.confirm("Are you sure you want to close CSV modal? The data will remove automatically.")
        if( ! result ) return false
      }
      setResponseMessage()
      resetFileInput()
      setIsLoading({
        uploadingCSV: false,
        importingCSV: false
      })
      MicroModal.close('msync-upload-csv-modal')
    }

    return (
        <>
            <Modal
              modalId={ props.modalId ?? 'msync-upload-csv-modal' }
              modalHeading={'Upload Members via CSV'}
              classNames={ props.classNames ?? '' }
              modalClassNames={ modalClassNames ?? '' }
              buttonTitle={ props.buttonTitle ?? 'Upload Team Members(CSV)' } 
            >
                <main className="msync-modal__body msync-upload-csv">
                { responseMessage && <ResponseMessage response={ responseMessage } /> }
                    <div className="msync-modal-upload-container msync-col">
                        <div className="msync-modal-upload-container">
                            <div className="msync-flex msync-flex--wrap">
                                <label>
                                    <div class="msync-label msync-required">Upload CSV</div>
                                    <input ref={fileInputRef} type="file" className="msync-file-input"
                                    onChange={(e) => inputFileChange(e)}
                                    onClick={(e) => resetFileInput()} 
                                    />
                                </label>
                                <button type="button" className="msync-button msync-button-md msync-filled-primary-button msync-margin-block-auto msync-margin-inline-start-auto" onClick={uploadCsv} disabled={isLoading.uploadingCSV}>
                                    { isLoading.uploadingCSV ? 'Uploading...' : 'Upload File' }
                                </button>
                            </div>
                            <div className='msync-modal-upload-container msync-row msync-download-template'>
                                <p>Download <a href={`${team['csv_sample']}`} target="_blank" download={`${team['csv_file_name']}`}>template CSV</a></p>
                            </div>
                        </div>
                        
                        { uploadCsvResponse && (
                                <>
                                    { team.team_type === 'wooteams' && <div className="msync-modal-upload-container msync-col msync-to-import mt-5">
                                        {/* 
                                            as of now, no integrity check on the back-end so I commented it for now.
                                        <div className="msync-modal-upload-container msync-row msync-between">
                                            <strong>CSV Integrity Check</strong>
                                        </div>
                                        <div className="msync-message-csv">
                                            <p className='msync-message-response-success-text'>File has no errors</p>
                                        </div> */}
                                        <div className="msync-modal-upload-container msync-row msync-between">
                                          <div>
                                            <strong>Seat Status</strong>
                                            <p className={`msync-seat-status ${ !uploadCsvResponse.isAllowedToImport && 'msync-error' }`}>
                                                { uploadCsvResponse.rowcount } rows to import / { team.team_seat_count === null ? 'unlimited seat' : `${team.team_remaining_seat} available seats`}</p>
                                          </div>
                                          { !uploadCsvResponse.isAllowedToImport && (
                                            <button type="button" className='msync-button msync-button-md msync-outline-primary-button' onClick={ handleAddSeatBtn } >{seatBtn}</button>
                                          )}
                                        </div>
                                    </div> }
                                    
                                    <TableCsvMapping tableData={tableData} setTableData={setTableData} canManage={canUseTeamIdOption} team={team} />
                                </>
                        )}
                        <div className='msync-modal-upload-container msync-grid msync-grid--density-8'>
                            {/* No back-end support for this as of now 
                            <label htmlFor="">No header exists</label>
                            <input type="checkbox" id="msync-no-header-exist" />  */}
                            {
                                !uploadCsvResponse && (
                                    <>
                                      {
                                        team.is_admin &&
                                        <div className='msync-import-behavior msync-grid msync-grid--density-8'>
                                            <strong class="msync-label">User import behavior</strong>
                                            <div class="msync-flex msync-flex--wrap">
                                                <div className="msync-inline-choice">
                                                    <input type="radio" id="automatically_add_uploaded_users" value="automatic"  name="csv_import_option" onChange={()=>checkImportOption('automatic')} checked={importOptions.importOption === 'automatic'} />
                                                    <label for="automatically_add_uploaded_users">Auto-add members</label>
                                                </div>
                                                <div className="msync-inline-choice">
                                                    <input type="radio" id="invite_uploaded_users" value="invite" name="csv_import_option" onChange={()=>checkImportOption('invite')} checked={importOptions.importOption === 'invite'} />
                                                    <label for="invite_uploaded_users">Invite members</label>
                                                </div>
                                            </div>
                                        </div>
                                      }
                                      <div className="msync-toggle">
                                        <input type="checkbox" id="msync-ignore-users" style={{ margin: "0" }} onChange={checkHandlerIgnoreUsers} />
                                        <label htmlFor="msync-ignore-users">Ignore users who are already members</label>
                                      </div>
                                    </>
                                )
                            }
                          
                        </div>
                    </div>
                </main>
                { uploadCsvResponse && (
                    uploadCsvResponse.isAllowedToImport && (
                        <footer className='msync-modal__footer'>
                            <button type="button"
                            className="msync-button msync-button-md msync-filled-primary-button msync-to-import"
                            onClick={importAction}
                            disabled={isLoading.importingCSV}
                            >
                                { isLoading.importingCSV ? 'Importing...' : 'Import' }
                            </button>
                        </footer>
                    )
                )}
            </Modal>
            {<>
                <Modal modalId="msync-modal-processing-import" modalHeading={'Your CSV is being Processed'} buttonTitle=""  modalClassNames={ modalClassNames ?? '' }>
                    <ProcessingCSV team={team} uploadCsvResponse={uploadCsvResponse} mapCsvResponse={mapCsvResponse} resetFileInput={resetFileInput} />
                </Modal>
                <Modal modalId="msync-modal-add-seats" modalHeading={'Add Seats'} buttonTitle="" classNames="" modalClassNames={ modalClassNames ?? '' }> 
                    <AddSeats team={team} />
                </Modal>
            </>}
        </>
    )
}

export default UploadCSV
